import { render, staticRenderFns } from "./StaticPages.vue?vue&type=template&id=5cb2bc46&scoped=true"
import script from "./StaticPages.vue?vue&type=script&lang=js"
export * from "./StaticPages.vue?vue&type=script&lang=js"
import style0 from "./StaticPages.vue?vue&type=style&index=0&id=5cb2bc46&prod&lang=scss&scoped=true"
import style1 from "./StaticPages.vue?vue&type=style&index=1&id=5cb2bc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2bc46",
  null
  
)

export default component.exports